import { render, staticRenderFns } from "./simpleClockapp.vue?vue&type=template&id=1168c16c&scoped=true"
import script from "./simpleClockapp.vue?vue&type=script&lang=js"
export * from "./simpleClockapp.vue?vue&type=script&lang=js"
import style0 from "./simpleClockapp.vue?vue&type=style&index=0&id=1168c16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168c16c",
  null
  
)

export default component.exports